import { createIdleLogout } from "@/hooks/createIdleLogout";
import { useAdminAuthStore } from "@/stores/adminAuthStore";

export const useIdleLogout = createIdleLogout(useAdminAuthStore, "/admin/signin");
